import React, { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { saveGeneratedImage } from 'reactApp/modules/aiPhotoGeneration/aiPhotoGeneration.actions';
import { openAiGenerationResetModal } from 'reactApp/ui/AiPhotoGeneration/AiGenerationResetModal/AiGenerationResetModal.helpers';
import { AiPhotoGenerationButtonRefresh } from 'reactApp/ui/AiPhotoGeneration/ToolbarComplete/ButtonRefresh/AiPhotoGenerationButtonRefresh';
import { AiPhotoGenerationButtonSave } from 'reactApp/ui/AiPhotoGeneration/ToolbarComplete/ButtonSave/AiPhotoGenerationButtonSave';
import { Delimiter } from 'reactApp/ui/ReactViewer/AiImprove/Buttons';
import { sendXray } from 'reactApp/utils/ga';

import styles from './AiPhotoGenerationToolbarComplete.css';

export const AiPhotoGenerationToolbarComplete = memo(function AiPhotoGenerationToolbarComplete() {
    const dispatch = useDispatch();

    const handleReset = useCallback(() => {
        openAiGenerationResetModal();
    }, []);

    const handleSave = useCallback(() => {
        sendXray(['ai-gen', 'save', 'click']);
        dispatch(saveGeneratedImage());
    }, [dispatch]);

    return (
        <div className={styles.root} data-test-id="ai-photo-generation-toolbar-complete">
            <div className={styles.container}>
                <Delimiter />
                <AiPhotoGenerationButtonRefresh onClick={handleReset} />
                <AiPhotoGenerationButtonSave onClick={handleSave} />
            </div>
        </div>
    );
});

AiPhotoGenerationToolbarComplete.displayName = 'AiPhotoGenerationToolbarComplete';
